// ============================================================
// エラーオブジェクトを読みやすい文字列に整形
// ============================================================
// Supabase JS のエラーは Error instance ではなく { message, code, details, hint } 形式
// JS のデフォルト `String(obj)` だと "[object Object]" になってしまうため、
// よくある形式を抽出して人間が読める文字列に変換する。
// ============================================================

export function formatErr(e: unknown): string {
  if (e instanceof Error) return e.message;
  if (typeof e === 'string') return e;
  if (e && typeof e === 'object') {
    const err = e as { message?: string; code?: string; details?: string; hint?: string };
    if (err.message) {
      const parts = [err.message];
      if (err.code) parts.push(`[${err.code}]`);
      if (err.hint) parts.push(`(${err.hint})`);
      return parts.join(' ');
    }
    try {
      return JSON.stringify(e);
    } catch {
      return String(e);
    }
  }
  return String(e);
}
